import { httpClient, postProcessUpsert } from "@genai/http-client";
import { ApiAssistant, CreateAssistantForm } from "../model";
import { toAssistant } from "./toAssistant";


export function createAssistant(createAssistantForm: CreateAssistantForm) {
  return httpClient("/assistants", {
    method: "POST",
    body: JSON.stringify(createAssistantForm),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(postProcessUpsert<ApiAssistant>)
    .then(toAssistant);
}
